import { createContext } from "react";

const CommunityContext = createContext({});

export default CommunityContext;
